import React, { useEffect, useState } from 'react';
import Hdfc from '../assets/images/hdfc.png'
import After from '../assets/images/Vectorafter.png'
import Afteractive from '../assets/images/VectorActive.png'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../assets/images/Logo.png'
import Usa from '../assets/images/Usa.png'
import Cad from '../assets/images/Cnd.png'
import Nocheck from '../assets/images/nocheck.png'
import Yescheck from '../assets/images/yescheck.png'
import Aedimg from '../assets/images/Aed.png'
import AuthService from '../services/auth.service';
import { AppDispatch, RootState } from '../app/store';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWallet } from '../app/slice/walletSlice';
import { showToast } from '../app/slice/toastsSlice';

// interface bankDetails {
//     account_holder: string,
//     account_number: number
//     bank_name: string
//     bank_type: string,
//     id: string,
//     ifsc_code: string
// }
function Aed() {
    const [loading, setLoading] = useState(false);
    const walletAmount = useSelector((state: RootState) => state.wallet.wallet);
    const [wallet, setWallet] = useState<any | Number>(walletAmount);
    const [showmethod, setMethod] = useState(false);
    const handleClosemethod = () => setMethod(false);
    const handleShowmethod = () => setMethod(true);
    const [banksList, setBanksList] = useState<any>([]);
    const [selectedBank, setSelectedBank] = useState<any>();
    const [withdrawalAmount, setWithdrawalAmount] = useState<any>('');
    const [message, setMessage] = useState("");
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    // State to track the index of the clicked <li>
    const [selectedCurrency, setSelectedCurrency] = useState<number | null>(null);

    // Handle the click event on the form-check div
    const handleClickCurrency = (index: number) => {
        setSelectedCurrency(index); // Set the clicked index
    };

    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    // Handle the click event on the form-check div
    const handleClick = (index: number) => {
        setSelectedIndex(index); // Set the clicked index
    };

    useEffect(() => {
        getBanks();
    }, []);

    useEffect(() => {
        setWallet(walletAmount);
    }, [walletAmount]);

    useEffect(() => {
        dispatch(fetchWallet());
    }, [dispatch]);

    function getBanks() {
        AuthService.bankList()
            .then(
                (response) => {
                    // console.log(response.data);
                    if (response.status === 200) {
                        setBanksList(response?.data);
                    } else {
                        setMessage(response?.message);
                    }
                }
            ).catch((error) => {
                const message = error?.response?.data?.error_description;
                setMessage(message);
                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                }
            }).finally(() => {
                //setIsPageLoading(false);
            });

    }

    function maskify(cc: any) {
        return cc.slice(0, -4).replace(/./g, '*') + cc.slice(-4);
    }


    const onChangeAmount = (e: any) => {
        //let amount = Number(e.target.value); 
        if (!isNaN(e.target.value)) {
            setWithdrawalAmount(e.target.value);
        }
    };

    const handleQuickAmount = (event: any, amt: number) => {
        event.preventDefault();
        if (amt > wallet?.user_combined_wallet) {
            setWithdrawalAmount(wallet?.user_combined_wallet);
            return;
        }
        setWithdrawalAmount(Number(amt).toFixed(2));
    };

    const handleWithdraw = () => {
        if (loading) return;
        setLoading(true);
        let formData = {
            id: selectedBank?.id,
            bank_type: selectedBank?.bank_type,
            amount: withdrawalAmount
        }
        // console.log(formData); return
        AuthService.withdraw(formData).then(
            (response) => {
                if (response.status === 200) {
                    setMessage(response.message);
                    setWithdrawalAmount('');
                    setSelectedBank(undefined);
                    formData = {
                        id: '',
                        bank_type: '',
                        amount: ''
                    };
                    let toast = {
                        type: 'success',
                        title: 'Success',
                        message: response.message
                    }
                    dispatch(showToast(toast));
                } else {
                    setMessage(response?.message);
                }

            }
        ).catch((error: any) => {
            const message = error?.response?.data?.error_description;
            setMessage(message);
            if (error?.response?.data?.status === 401) {
                localStorage.removeItem("w_token");
                navigate('/login');
            } else {
                let toast = {
                    type: 'error',
                    title: 'Error',
                    message: message
                }
                dispatch(showToast(toast));
            }
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <>
            <style>
                {`
        .selectCurrency.modal.fade .modal-dialog {
            transition: transform .3s ease-out;
          transform: translate(0%,100%) !important;
          }
          .selectCurrency.modal.show .modal-dialog{
            transform: none !important;
          }
          @media screen and (min-width: 1024px) {
            .selectCurrency.modal.fade .modal-dialog {
              transition: transform .3s ease-out;
              transform: translate( 100%,0%) !important;
            }
            .selectCurrency.modal.show .modal-dialog{
              transform: none !important;
            }
          }
        `}
            </style>
            <div className="container">
                <div className="row">
                    <div className="col-12 bankDetal mt-2" style={{ background: 'none' }}>
                        <div className="bitcoin">
                            <div>
                                <label className="mt-0">Withdrawal Amount <sup style={{ color: '#F75653' }}>*</sup></label>
                                <button>
                                    <span className="d-flex align-items-center">
                                        <img src={Aedimg} alt="" className='img-fluid' />
                                        <span className="ms-1">
                                            <p>Aed</p>
                                        </span>
                                    </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                                        <path d="M6.5 7.24316L0.0136719 0.756836H12.9863L6.5 7.24316Z" fill="white" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="bitcoin">
                            <div>
                                <label>Choose Bank from Beneficiary <sup style={{ color: '#F75653' }}>*</sup></label>
                                <button className='text-white' onClick={handleShowmethod}>
                                    {selectedBank?.bank_name ? selectedBank?.bank_name : 'Select Bank'}
                                    <svg style={{ marginLeft: 'auto' }} xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                                        <path d="M6.5 7.24316L0.0136719 0.756836H12.9863L6.5 7.24316Z" fill="white" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        {/* <div className="bitcoin">
                            <div>
                                <label>Bank Name <sup style={{ color: '#F75653' }}>*</sup></label>
                                <button className='text-white'>
                                Yessss
                                    <svg style={{marginLeft:'auto'}} xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                                        <path d="M6.5 7.24316L0.0136719 0.756836H12.9863L6.5 7.24316Z" fill="white" />
                                    </svg>
                                </button>
                            </div>
                        </div> */}
                        <label>Account Number <sup style={{ color: '#F75653' }}>*</sup></label>
                        <div className="inputBank">
                            <input className="trxId" type="text" placeholder='' style={{ letterSpacing: '1px' }} value={selectedBank?.account_number || ''} readOnly />
                        </div>
                        <label>Account Holder Name <sup style={{ color: '#F75653' }}>*</sup></label>
                        <div className="inputBank">
                            <input className="trxId" type="text" placeholder='' value={selectedBank?.account_holder || ''} readOnly />
                        </div>
                        <label>IFSC Code <sup style={{ color: '#F75653' }}>*</sup></label>
                        <div className="inputBank">
                            <input className="trxId" type="text" placeholder='' style={{ letterSpacing: '1px' }} value={selectedBank?.ifsc_code || ''} readOnly />
                        </div>
                        <div className='d-flex align-items-center justify-content-between'>
                            <label>Withdraw Amount <sup style={{ color: '#F75653' }}>*</sup></label>
                            <label className='availBal'>Available Bal: ₹ <span style={{ color: '#fff', opacity: '1' }}>{wallet?.user_combined_wallet || ''}</span></label>
                        </div>
                        <div className="inputBank">
                            <input className="trxId" name="withdraw_amount" type="text" placeholder='Enter amount' value={withdrawalAmount} onChange={onChangeAmount} />
                        </div>
                        <label>Quick Select Amount</label><br />
                        <button className='withdrawBtn' onClick={e => handleQuickAmount(e, wallet?.user_combined_wallet)}>Max</button>
                        <button className='withdrawBtn' onClick={e => handleQuickAmount(e, wallet?.user_combined_wallet / 2)}>50%</button>
                        {message && (
                            <div className='d-block text-danger text-center' role="alert">
                                {message}
                            </div>
                        )}
                        <button className='addMony mt-3' onClick={!loading ? () => handleWithdraw() : undefined} disabled={withdrawalAmount === '' || Number(withdrawalAmount) === 0 || selectedBank===undefined ||loading ? true : false}>
                            {loading ?
                                <>
                                    Please wait...
                                </>
                                :
                                <>
                                    Withdraw
                                </>
                            }
                        </button>
                    </div>
                </div>
            </div>
            <Modal show={showmethod} onHide={handleClosemethod} className='selectCurrency modal-slide-up'>
                <Modal.Body>
                    <div className="col-12">
                        <form className='depositAmount mt-3 addBanklist'>

                            <div className='paymentGetway mt-3'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <h6>Select Bank Account</h6>
                                    <Link to='/add-bank'>
                                        <Button className='addAcount'>+ Add Bank</Button>
                                    </Link>
                                </div>
                                <ul className='bankList'>
                                    {banksList?.length > 0 && banksList?.map((key: any, index: number) => (
                                        <li
                                            className={selectedBank?.id === key?.id ? 'selected' : ''} key={index} onClick={() => { setSelectedBank(key); handleClosemethod() }}
                                        >
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <img src={Hdfc} alt="Hdfc" className='img-fluid' />
                                                    <div>
                                                        <p>{key?.bank_name}</p>
                                                        <p>{key?.account_number}</p>
                                                    </div>
                                                </div>
                                                <img src={After} alt="After" className='img-fluid after' />
                                                <img src={Afteractive} alt="After" className='img-fluid afterActive' />
                                            </div>
                                            <div className="form-check" onClick={() => handleClick(0)}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefault"
                                                    id="flexRadioDefault1"
                                                />
                                                <label className="form-check-label">
                                                    Default radio
                                                </label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default Aed;